import React from 'react';
import Badge from './Badge';

// Mappa dei valori numerici ai corrispondenti stati in italiano per la sottoscrizione di file
const stateMap = {
    0: { label: "Caricato", badgeClass: "bg-info" },
    1: { label: "Validato", badgeClass: "bg-success" },
    2: { label: "Rifiutato", badgeClass: "bg-danger" },
    3: { label: "Pagato", badgeClass: "bg-warning" }
};

const StateFileSub = ({ stateValue }) => {
    // Verifica l'esistenza della voce nella mappa e imposta valori di default se non trovata
    const stateInfo = stateMap[stateValue] || { label: "Stato Sconosciuto", badgeClass: "bg-secondary" };

    return <Badge badgeStatus={stateInfo.badgeClass} badgeText={stateInfo.label} />;
};

export default StateFileSub;